var render = function render(){var _vm=this,_c=_vm._self._c;return _c('order-timeline-box',{attrs:{"title":_vm.__('orders.states.' + _vm.OrderState.Cancelled),"title-class":"text-danger","badge-class":"bg-danger","message":_vm.users[_vm.logsByState[_vm.OrderState.Cancelled].issuer_uid],"timestamp":_vm.logsByState[_vm.OrderState.Cancelled].created_at,"icon":"fa-ban","complete":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }